<template>
    <div class="text-center" >
      <h2 class="inline-block" v-if="message" >{{ message }}</h2>
      <br>
      <bounce-loader v-if="loaderType === 'bounce'" class="" :loading="show" :color="color" :size="size"></bounce-loader>
      <clip-loader v-if="loaderType === 'clip'" class="inline-block" :loading="show" :color="color" :size="size"></clip-loader>
      <scale-loader v-if="loaderType === 'scale'" class="inline-block" :loading="show" :color="color" :size="size"></scale-loader>
      <beat-loader v-if="loaderType === 'beat'" class="inline-block" :loading="show" :color="color" :size="size"></beat-loader>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'cgLoader',
    props: {
      color: {
        type: String,
        default: this.loaderColor
      },
      show: {
        type: Boolean,
        default: false
      },
      message: {
        type: String,
        default: 'laden ...'
      },
      size: {
        type: String,
        default: '100px'
      },
      loaderType: {
        type: String,
        default: 'scale'
      }
    },
    computed: {
      ...mapGetters({
        loaderColor: 'options_loader_color'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/menus/cgLoader.vue